import React from 'react'

const NestedMenuCTA = ({ cta }) => {
	const { image_url: imageSrc, image_alt: imageAlt, eyebrow, title, url } = cta

	return (
		<li  className="header-cta">
			<h4 className="header-cta__title">
				<a href={url} className="header-cta__title__link wp-block-button__link">
					{title}
				</a>
			</h4>
			{eyebrow && <p className="header-cta__eyebrow">{eyebrow}</p>}
			<div className="header-cta__image-container">
				<img className="header-cta__image" loading="lazy" src={imageSrc} alt={imageAlt} />
			</div>
		</li>
	)
}

export default NestedMenuCTA